import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "main-gradient-info mb-10 mt-5" }
const _hoisted_2 = { class: "relative container" }
const _hoisted_3 = { class: "flex p-3" }
const _hoisted_4 = { class: "mb-2 text-primary" }
const _hoisted_5 = { class: "ml-5 text-white" }
const _hoisted_6 = { class: "flex flex-col items-center text-white" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-md text-white mb-0 p-2 border-gray-300" }, "۸۰۰ نفر ", -1)
const _hoisted_8 = { class: "absolute left-0 bottom-0 top-0 m-[20px] flex gap-4 flex-col items-center" }
const _hoisted_9 = {
  class: "w-[150px] h-[150px]",
  alt: ""
}
const _hoisted_10 = { class: "container" }
const _hoisted_11 = { class: "text-lg my-[20px]" }
const _hoisted_12 = { class: "grid grid-cols-2 grid-flow-row-reverse gap-2 md:grid-cols-6" }
const _hoisted_13 = { class: "flex flex-col bg-vt-dark rounded-md text-white p-[10px] gap-[10px]" }
const _hoisted_14 = { class: "flex gap-[10px]" }
const _hoisted_15 = ["alt"]
const _hoisted_16 = { class: "flex flex-col gap-[10px] p-[10px]" }
const _hoisted_17 = { class: "flex justify-between" }
const _hoisted_18 = ["alt"]
const _hoisted_19 = { class: "" }
const _hoisted_20 = { class: "flex justify-between" }
const _hoisted_21 = ["alt"]
const _hoisted_22 = { class: "" }
const _hoisted_23 = { class: "flex gap-[10px] border-t-2 border-dotted border-[#afb1b9] pt-2" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-[20px]",
  alt: "",
  src: "https://static.varzesh3.com/img/icons/date-icon2.svg"
}, null, -1)
const _hoisted_25 = { class: "text-xs" }
const _hoisted_26 = { class: "md:flex-auto md:w-[30%]" }
const _hoisted_27 = { class: "bg-white rounded-md mr-2 mb-3 mt-2 sm:flex sm:flex-col xs:flex-col xs:mr-0 sm:mr-0 md:mr-0" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("h3", { class: "p-3 m-0 mr-[3px] pr-[3px] text-lg bg-vt-dark text-white rounded-t-md" }, "جدول رده بندی", -1)
const _hoisted_29 = { class: "m-2 p-2" }
const _hoisted_30 = { class: "w-full" }
const _hoisted_31 = { class: "w-full" }
const _hoisted_32 = { class: "gap-[10px]" }
const _hoisted_33 = { class: "w-[15%] pb-3" }
const _hoisted_34 = { class: "w-[55%] pb-3" }
const _hoisted_35 = { class: "w-[20%] pb-3" }
const _hoisted_36 = { class: "w-[15%] pb-3" }
const _hoisted_37 = { class: "px-2 py-2 text-sm" }
const _hoisted_38 = { class: "py-2 flex" }
const _hoisted_39 = ["alt"]
const _hoisted_40 = { class: "py-2 text-sm" }
const _hoisted_41 = { class: "py-2 text-sm" }
const _hoisted_42 = { class: "bg-white rounded-md mr-2 mb-2 mt-2 pb-1 xs:mr-0 sm:mr-0 md:mr-0" }
const _hoisted_43 = { class: "p-3 m-0 mr-[3px] pr-[3px] text-lg bg-vt-dark text-white rounded-t-md" }
const _hoisted_44 = { class: "p-2 max-h-[600px] overflow-auto" }
const _hoisted_45 = { class: "flex gap-6" }
const _hoisted_46 = {
  class: "shadow-follow-box rounded-full w-[70px] h-[70px]",
  alt: ""
}
const _hoisted_47 = {
  class: "shadow-follow-box rounded-full w-[70px] h-[70px]",
  alt: ""
}
const _hoisted_48 = { class: "flex-col flex-[50%] gap-9" }
const _hoisted_49 = { class: "flex justify-content-between align-items-center mb-2" }
const _hoisted_50 = { class: "flex justify-start gap-1 flex-wrap" }
const _hoisted_51 = { class: "flex" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined text-[#ff7322]" }, "#", -1)
const _hoisted_53 = { class: "" }
const _hoisted_54 = {
  key: 0,
  class: "w-full"
}
const _hoisted_55 = { class: "search-material md:flex-auto md:w-[70%]" }
const _hoisted_56 = { class: "flex-auto flex-wrap mt-2 pb-2" }
const _hoisted_57 = { class: "flex justify-between bg-white rounded-md mb-2" }
const _hoisted_58 = { class: "p-4 m-0 text-lg" }
const _hoisted_59 = { class: "grid grid-cols-1 md:grid-cols-2 gap-2 w-full sm:grid sm:grid-cols-1 xs:grid xs:grid-cols-1" }
const _hoisted_60 = { class: "flex-none" }
const _hoisted_61 = {
  class: "rounded-md h-[100px]",
  alt: "img"
}
const _hoisted_62 = { class: "flex-grow p-2" }
const _hoisted_63 = {
  class: "h-[20px] text-dark overflow-hidden no-underline text-base",
  href: ""
}
const _hoisted_64 = { class: "text-gray-400 text-xs h-[29px] overflow-hidden w-full" }
const _hoisted_65 = {
  id: "search-material",
  class: "flex gap-6 justify-between"
}
const _hoisted_66 = { class: "flex gap-2" }
const _hoisted_67 = { class: "view text-gray-400 text-xs" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary material-icons text-sm" }, "visibility", -1)
const _hoisted_69 = { class: "time text-gray-400 text-xs" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary material-icons text-sm" }, "schedule", -1)

import {useApi} from '../../utils/api';
  import { ref, onMounted, watch} from "vue";
  import { useRoute } from 'vue-router';
  import jalaliMoment from 'moment-jalaali';
  import VTButton from '@/elements/VTButton'; 
//   import type { Header, Item, HeaderItemClassNameFunction, BodyItemClassNameFunction } from "vue3-easy-data-table";
//   import { usePagination, useRowsPerPage } from "use-vue3-easy-data-table";
//   import type { UsePaginationReturn, UseRowsPerPageReturn } from "use-vue3-easy-data-table";
  import { useToast } from "vue-toast-notification";
  import { useI18n } from "vue-i18n";  
  import { useAuthStore } from '../../stores/auth';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'info',
  setup(__props) {

 
  const { t } = useI18n();


const authStore = useAuthStore();
const info = ref([]);
const posts = ref([]);
const videos = ref([]);
const clubs = ref([]);
const matches = ref([]);
const category = ref([]);

const $toast = useToast();

const route = useRoute();
const active = ref(false);

const getData = () => {
useApi().get(`/api/club/${route.params.id}`)
    .then((response) => {
        category.value = response.data?.category;
        info.value = response.data?.info;
        posts.value = response.data?.posts;
        videos.value = response.data?.videos;
        clubs.value = response.data?.clubs;
        matches.value = response.data?.matches;

        window.document.title =   `${info.value?.title} | ${t('site.Website name')}`;
    });
}

const follow = (clubId: Number) => {
    useApi().post(`/api/favorite/clubs/${clubId}`)
        .then((response) => {
            if (response.data?.status == 1) {
                active.value = response.data.active;
                $toast.success(response.data.message);
            } else {
                $toast.error(response.data.message);
            }
        });
  }

const followers = ref([]);
const page = ref(1);
const more = ref(false);
const loading = ref(false);

const getFollowers = () => {
    loading.value = true;

    if (page.value == 1) {
        followers.value = [];
    }

    useApi().post(`/api/club/${route.params.id}/followers`)
        .then((response) => {

            followers.value.push(...response.data.data);

            if (response.data.total > page.value * response.data.per_page) {
                more.value = true;
            } else {
                more.value = false;
            }

            page.value++;
        })
        .finally(() => {
            loading.value = false;
        })
}

    watch(() => route.params.id, () => {
        if (route.params.id) {
            page.value = 1;
            getData();
            getFollowers();
        } 
    });

    const getActive = () => {
        useApi().get(`/api/profile/clubs/active/${route.params.id}`)
            .then((response) => {
                active.value = response.data?.active;
            });
        }

    const loginWarning = () => {
        $toast.error(t('site.Please login for follow the club'))
    }

    onMounted(() => {
        getData();
        getFollowers();
        if (authStore?.user?.id) {
            getActive();
        }
    });




return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(info.value?.sport?.title), 1),
            _createElementVNode("h1", _hoisted_5, _toDisplayString(info.value?.title), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            (_unref(authStore)?.user?.id > 0)
              ? (_openBlock(), _createBlock(_unref(VTButton), {
                  key: 0,
                  loading: loading.value,
                  disabled: loading.value,
                  class: "w-full justify-center btn-outline-secondary btn-sm",
                  size: "medium",
                  color: "primary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (follow(info.value?.id)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(active.value ? _ctx.$t('site.Unfollow') : _ctx.$t('site.Follow')), 1)
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"]))
              : (_openBlock(), _createBlock(_unref(VTButton), {
                  key: 1,
                  onClick: loginWarning,
                  class: "w-full justify-center btn-outline-secondary btn-sm",
                  size: "medium",
                  color: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('site.Follow')), 1)
                  ]),
                  _: 1
                }))
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _withDirectives(_createElementVNode("img", _hoisted_9, null, 512), [
            [_directive_lazy, info.value.image]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t("site.Club latest results")) + " " + _toDisplayString(info.value?.title), 1)
      ]),
      _createElementVNode("div", _hoisted_12, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(matches.value, (match, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "rounded-md w-full bg-white"
          }, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _withDirectives(_createElementVNode("img", {
                  class: "w-[20px] h-[20px]",
                  alt: match?.step?.league?.title
                }, null, 8, _hoisted_15), [
                  [_directive_lazy, match?.step?.league?.image]
                ]),
                _createElementVNode("span", null, _toDisplayString(match?.step?.league?.title), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_router_link, {
                  class: "text-gray-500 text-decoration-none flex gap-2 items-center justify-content-center",
                  to: `/club/${match?.team_home?.id}`,
                  title: match?.team_home?.title
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("img", {
                      class: "rounded-full w-[25px] h-[25px]",
                      alt: match?.team_home?.title
                    }, null, 8, _hoisted_18), [
                      [_directive_lazy, match?.team_home?.image]
                    ]),
                    _createElementVNode("span", null, _toDisplayString(match?.team_home?.title), 1)
                  ]),
                  _: 2
                }, 1032, ["to", "title"]),
                _createElementVNode("div", _hoisted_19, _toDisplayString(match?.hsc), 1)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_router_link, {
                  class: "text-gray-500 text-decoration-none flex gap-2 items-center justify-content-center",
                  to: `/club/${match?.team_away?.id}`,
                  title: match?.team_away?.title
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("img", {
                      class: "rounded-full w-[25px] h-[25px]",
                      alt: match?.team_away?.title
                    }, null, 8, _hoisted_21), [
                      [_directive_lazy, match?.team_away?.image]
                    ]),
                    _createElementVNode("span", null, _toDisplayString(match?.team_away?.title), 1)
                  ]),
                  _: 2
                }, 1032, ["to", "title"]),
                _createElementVNode("div", _hoisted_22, _toDisplayString(match?.asc), 1)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(jalaliMoment)(match.date).format('dddd jD jMMMM - HH:mm')), 1)
              ])
            ])
          ]))
        }), 128))
      ]),
      (_openBlock(), _createElementBlock("div", {
        class: "md:flex mt-2 gap-3",
        key: info.value?.id
      }, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("table", _hoisted_30, [
                _createElementVNode("thead", _hoisted_31, [
                  _createElementVNode("tr", _hoisted_32, [
                    _createElementVNode("th", _hoisted_33, _toDisplayString(_ctx.$t('site.Row')), 1),
                    _createElementVNode("th", _hoisted_34, _toDisplayString(_ctx.$t('site.Team')), 1),
                    _createElementVNode("th", _hoisted_35, _toDisplayString(_ctx.$t('site.Game count')), 1),
                    _createElementVNode("th", _hoisted_36, _toDisplayString(_ctx.$t('site.Points')), 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clubs.value, (club, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: index,
                      class: _normalizeClass({'bg-[#d1d5db]' : club.id === info.value.id})
                    }, [
                      _createElementVNode("td", _hoisted_37, _toDisplayString(index + 1), 1),
                      _createElementVNode("td", _hoisted_38, [
                        _withDirectives(_createElementVNode("img", {
                          class: "rounded-full w-[25px] h-[25px] mx-1",
                          alt: club.title,
                          width: "30"
                        }, null, 8, _hoisted_39), [
                          [_directive_lazy, club.image]
                        ]),
                        _createVNode(_component_router_link, {
                          title: club.title,
                          to: `/club/${club.id}`,
                          class: "no-underline text-base text-black"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(club.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["title", "to"])
                      ]),
                      _createElementVNode("td", _hoisted_40, _toDisplayString(club?.pivot?.games_count), 1),
                      _createElementVNode("td", _hoisted_41, _toDisplayString(club?.pivot?.points), 1)
                    ], 2))
                  }), 128))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("h3", _hoisted_43, _toDisplayString(_ctx.$t('site.Fans')), 1),
            _createElementVNode("div", _hoisted_44, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(followers.value, (follower, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "mb-2 p-2 bg-[#f0f8ff] rounded-md"
                }, [
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", null, [
                      (_unref(authStore)?.user?.id > 0)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: `/member/${follower.id}`,
                            title: follower.nickname,
                            class: "no-underline"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("img", _hoisted_46, null, 512), [
                                [_directive_lazy, follower.profile_photo_path]
                              ])
                            ]),
                            _: 2
                          }, 1032, ["to", "title"]))
                        : (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            onClick: loginWarning,
                            class: "cursor-pointer no-underline"
                          }, [
                            _withDirectives(_createElementVNode("img", _hoisted_47, null, 512), [
                              [_directive_lazy, follower.profile_photo_path]
                            ])
                          ]))
                    ]),
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        (_unref(authStore)?.user?.id > 0)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: `/member/${follower.id}`,
                              title: follower.nickname,
                              class: "no-underline text-base text-black"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(follower.nickname), 1)
                              ]),
                              _: 2
                            }, 1032, ["to", "title"]))
                          : (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              onClick: loginWarning,
                              class: "cursor-pointer no-underline text-base text-black"
                            }, _toDisplayString(follower.nickname), 1))
                      ]),
                      _createElementVNode("div", _hoisted_50, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(follower?.clubs, (club, index) => {
                          return (_openBlock(), _createBlock(_component_router_link, {
                            key: index,
                            to: `/club/${club.id}`,
                            class: "no-underline text-white text-sm border-1 borde-solid px-2 py-1 bg-vt-dark rounded-md"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_51, [
                                _hoisted_52,
                                _createElementVNode("span", _hoisted_53, _toDisplayString(club.title), 1)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        }), 128))
                      ])
                    ])
                  ])
                ]))
              }), 128)),
              (more.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                    _createVNode(_unref(VTButton), {
                      loading: loading.value,
                      disabled: loading.value,
                      class: "w-full justify-center btn-outline-secondary btn-sm",
                      size: "medium",
                      color: "primary",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (getFollowers()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('site.More post')), 1)
                      ]),
                      _: 1
                    }, 8, ["loading", "disabled"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("h3", _hoisted_58, _toDisplayString(_ctx.$t("site.Club news")) + " " + _toDisplayString(info.value?.title), 1),
              _createVNode(_component_router_link, {
                to: `/category/${category.value?.id}/${category.value?.slug}`,
                class: "text-decoration-none p-4 m-0 text-lg text-blue-400 hover:text-blue-600"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('site.Display all')), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("div", _hoisted_59, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(posts.value, (post, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "cursor-pointer",
                  key: index
                }, [
                  _createVNode(_component_router_link, {
                    to: post?.type == 1 ? `/video/${post.id}/${post.slug}` : `/news/${post.id}/${post.slug}`,
                    class: "text-decoration-none flex p-2 flex-nowrap flex-wrap items-center justify-center rounded-md bg-white hover:bg-gray-200 xs:flex xs:flex-col"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_60, [
                        _withDirectives(_createElementVNode("img", _hoisted_61, null, 512), [
                          [_directive_lazy, post.image]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_62, [
                        _createElementVNode("h3", _hoisted_63, _toDisplayString(post.title), 1),
                        _createElementVNode("p", _hoisted_64, _toDisplayString(post.summary), 1),
                        _createElementVNode("div", _hoisted_65, [
                          _createElementVNode("div", _hoisted_66, [
                            _createElementVNode("div", _hoisted_67, [
                              _hoisted_68,
                              _createTextVNode(" " + _toDisplayString(post.view), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_69, [
                            _hoisted_70,
                            _createTextVNode(" " + _toDisplayString(_unref(jalaliMoment)(post.created_at).format('dddd jD jMMMM')), 1)
                          ])
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              }), 128))
            ])
          ])
        ])
      ]))
    ])
  ], 64))
}
}

})